import { FormControl, FormHelperText, Typography } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import ReactQuill from "react-quill";
import { QuillStyle } from "../../_utils/quillStyle";
import { useTranslation } from "react-i18next";

const ControlledQuill = ({
  name,
  placeholder,
  control,
  noMargin,
  style,
  toolbar,
  readOnly,
  label,
  rules = {},
}: any) => {
  const { t } = useTranslation("common");
  const modules = {
    toolbar: [
      // [{ size: ["small", false, "large"] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
  ];

  return (
    <FormControl sx={{ width: "100%", mt: noMargin ? 0 : 2 }}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field, formState: { errors } }) => (
          <div>
            {label && (
              <Typography
                color={Boolean(errors?.[name]) ? "error" : "default"}
                fontWeight="bold"
                component="h4"
                sx={{ mb: 1 }}
              >
                {label}
              </Typography>
            )}
            <ReactQuill
              readOnly={readOnly}
              theme={toolbar ? "snow" : ""}
              style={!toolbar ? style ?? QuillStyle : {}}
              placeholder={placeholder}
              {...(toolbar ? { formats, modules } : {})}
              {...field}
            />
            {Boolean(errors?.[name]) && (
              <FormHelperText error>
                {Boolean(errors?.[name]?.message)
                  ? errors?.[name]?.message
                  : t("errors.required")}
              </FormHelperText>
            )}
          </div>
        )}
      ></Controller>
    </FormControl>
  );
};

export default ControlledQuill;
